import React, { useState } from "react";
import Wrapper from "./sidebarRightDesktop.styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { useSpring, animated } from "@react-spring/web";
import SidebarContent from "./sidebarContent";
import { useTheme } from 'styled-components';

const SidebarRightDesktop = ({ setShowNotifications }) => {
  const theme = useTheme();
  const getSessionStorageValue = (sessionStorage.getItem("expandedStatusRight")) === "true" ? true : false;
  const [isExpandedRightNav, setIsExpandedRightNav] = useState(getSessionStorageValue);

  const [springs, api] = useSpring(() => ({
    from: {  width: isExpandedRightNav? 340 : 60 },
  }));

  const handleExpandRightNav = () => {
    sessionStorage.setItem("expandedStatusRight", "true");
    setIsExpandedRightNav(true);
    api.start({
      from: {
        width: 60,
      },
      to: {
        width: 340,
      },
    });
  };

  const handleCollapseRightNav = () => {
    sessionStorage.setItem("expandedStatusRight", "false");
    setIsExpandedRightNav(false);
    api.start({
      from: {
        width: 340,
      },
      to: {
        width: 60,
      },
    });
  };

  return (
    <animated.div
      className="nav-right-desktop"
      style={{
        background: theme.palette.header.background,
        ...springs,
      }}
    >
      <Wrapper>
        <div className="sidebar">
          <button
            className="right-nav-expand"
            onClick={isExpandedRightNav ? handleCollapseRightNav : handleExpandRightNav}
          >
            <FontAwesomeIcon icon={faEllipsisV} color={theme.palette.header.active} size="lg" />
          </button>
          <SidebarContent setShowNotifications={setShowNotifications} isExpandedRightNav={isExpandedRightNav} shouldShowSidebarContent={true} menuSide="right" />
        </div>
      </Wrapper>
    </animated.div>
  );
};

export default SidebarRightDesktop;
